/**
 * ThemeProvider — class-based dark mode on <html>.
 * Reads from Zustand ui-store and applies the correct class.
 * Respects system preference when theme is 'system'.
 */

import { useEffect } from 'react';

import { useUIStore } from '@/stores/ui-store';

export default function ThemeProvider({ children }: { children: React.ReactNode }) {
  const theme = useUIStore((s) => s.theme);

  useEffect(() => {
    const root = document.documentElement;

    if (theme === 'system') {
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      root.classList.toggle('dark', prefersDark);

      // Listen for OS-level changes
      const mq = window.matchMedia('(prefers-color-scheme: dark)');
      const handler = (e: MediaQueryListEvent) => root.classList.toggle('dark', e.matches);
      mq.addEventListener('change', handler);
      return () => mq.removeEventListener('change', handler);
    }
    root.classList.toggle('dark', theme === 'dark');
    return undefined;
  }, [theme]);

  return <>{children}</>;
}
